import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { ScrollArea } from "@/components/ui/scroll-area";
import { titleize, displayValue } from "@/lib/format";
const HIDDEN = ["id", "_id", "__v", "password", "pass", "pwd", "owner_id", "user_id", "assigned_to", "connector_id",
  "upload_batch_id", "converted_app_id", "client_application_id", "bank_submission_id", "lead_id", "coordinator_id",
  "manager_id", "team_leader_id"];

export function RecordDetail({ open, onOpenChange, title, record, extra }) {
  const entries = record ? Object.entries(record).filter(([k, v]) => !HIDDEN.includes(k) && !(Array.isArray(v) && v.length === 0)) : [];
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl bg-white dark:bg-slate-900" data-testid="record-detail-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading text-xl">{title}</DialogTitle>
          <DialogDescription className="sr-only">Detailed record information</DialogDescription>
        </DialogHeader>
        <ScrollArea className="max-h-[65vh] pr-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-4 py-2">
            {entries.map(([k, v]) => (
              <div key={k} className="border-b border-slate-100 dark:border-slate-800 pb-2">
                <div className="text-xs font-semibold uppercase tracking-wider text-slate-400">{titleize(k)}</div>
                <div className="text-sm text-slate-800 dark:text-slate-200 font-num mt-0.5 break-words">{displayValue(k, v)}</div>
              </div>
            ))}
            {entries.length === 0 && <p className="text-sm text-slate-500">No details available.</p>}
          </div>
          {extra}
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
}
